
export class ReceivingInstructionDetailReturnRequest {
  adNoList: string[];
  language?: string;
  uuid?: string;

  constructor() {
    this.adNoList = [];
    this.language = undefined;
    this.uuid = undefined;
  }
}
